import React from 'react'
import CustomModal from '../../../../Shared/CustomModal'
import styles from './PDLDeviceDetails.module.css'
export default function PDLDeviceDetails () {
  return (
    <CustomModal
      id='pdlVehicleInfo'
      title='Device Details'
      size='modal-lg'
      header={true}
      closeBtnClass='btn ms_btn btn-default'
    >
      
      <div className={styles.modalBody}>
        <div className={styles.section}>
          {/* <div className={styles.sectionTitle}> Device Information </div> */}
          <div className='row g-2'>
            <div className='col-md-6'>
              <div className={styles.info}>
                <span>ICCID: </span> <strong>89916420534724377412</strong>
              </div>
            </div>
            <div className='col-md-6'>
              <div className={styles.info}>
                <span>DEVICE IMEI: </span> <strong>867018065625323</strong>
              </div>
            </div>
            <div className='col-md-6'>
              <div className={styles.info}>
                <span>UIN NO: </span> <strong>ACON4PA042300000388</strong>
              </div>
            </div>
            <div className='col-md-6'>
              <div className={styles.info}>
                <span>DEVICE MAKE: </span> <strong>ACCOLADE</strong>
              </div>
            </div>
            <div className='col-md-6'>
              <div className={styles.info}>
                <span>DEVICE MODEL: </span> <strong>AEPL052600</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  )
}
